/* eslint-disable promise/avoid-new */
/* eslint-disable import/no-unassigned-import */
/* eslint-disable class-methods-use-this */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
/* eslint-disable @typescript-eslint/require-await */
/* eslint-disable typescript-sort-keys/interface */
/* eslint-disable unicorn/prefer-query-selector */
/* eslint-disable require-atomic-updates */
/* eslint-disable no-extra-boolean-cast */
/* eslint-disable prefer-destructuring */
/* eslint-disable unicorn/no-for-loop */
/* eslint-disable sort-destructure-keys/sort-destructure-keys */
/* eslint-disable unicorn/prefer-spread */
/* eslint-disable id-denylist */
/* eslint-disable @typescript-eslint/await-thenable */
/* eslint-disable @typescript-eslint/consistent-type-assertions */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable jsdoc/require-jsdoc */
/* eslint-disable unicorn/catch-error-name */
/* eslint-disable spaced-comment */
/* eslint-disable unicorn/prevent-abbreviations */
/* eslint-disable @typescript-eslint/no-inferrable-types */

// @ts-nocheck

// Spec 4 (D1): milestone only — see the call site.
import { markRendererMilestone } from '#~/boot/renderer-startup.js';
import type { LiveKit } from '#~/livekit/types.js';
//import * as tf from '@tensorflow/tfjs';
//import '@tensorflow/tfjs-backend-webgpu';

import {
  FaceSample,
  SubjectClass,
  TrackingSample
} from '@tryiris-ai/common.protojs/autotracking/v2/annotation';
import { connect } from 'nats.ws';
import type { NatsConnection } from 'nats.ws';
import type { T_Maybe } from '@tryiris-ai/js-types';
import type { LiveKitImpl } from '#~/livekit/livekit.js';
import type { RemoteTrack } from 'livekit-client';

import DetectionWebWorker from './web-worker.js?worker';
import type { Device } from '@studio/models/device';
import type { Room } from '@studio/models/room';
import { createToken } from '#~/api/livekit/livekit.js';
import { generateId } from '@studio/models';
import { config } from '#~/config/config.js';

import type { Track as MegaTrack } from '#~/livekit/types.js';
import { SharedTimestampManager } from '#~/auto-tracking/provider/timestamp-manager.js';
import type { NewtsConnection } from '#~/newts/connection.js';
import { nats } from '#~/nats/index.js';
import type { Agent } from '@studio/models/agent';

import { image } from '@tensorflow/tfjs';
import { isElectronApp } from '#~/electron/utils.js';
import { onAutoTrackingReady } from '#~/electron/api.js';
import { broker } from '#~/agent/broker.js';
import { DetectionMode } from '@tryiris-ai/common.protojs/autotracking/v2/state';
import {
  trackerCPUMode,
  setTrackerCPUMode
} from '#~/control/components/interaction/autotracking/wiring.js';
import { toHexFromId, toIdFromHex } from '#~/api/utils.js';
import { PostHogManager, PostHogFeatureFlag } from '#~/posthog/index.js';
import { track } from '#~/analytics/index.js';
import { EVENT_CATEGORIES, EVENT_NAMES } from '#~/analytics/constants/index.js';

const modelPath = `https://` + window.location.host + '/assets/models/';

const classToPB = {
  0: SubjectClass.HEAD,
  1: SubjectClass.FACE,
  2: SubjectClass.FULL_BODY
};

export const autoTrackingFps: Record<string, number | null> = {};

export class TrackingDetector {
  #trackerMode: number = 1; //1 or 2
  #globalI: number = 0;
  #loaded: boolean = false;
  #detecting: boolean = false;
  #shouldDetect: boolean = false;
  #livekit: T_Maybe<LiveKitImpl>;
  #track: T_Maybe<MegaTrack>;

  #lastMeasurementRtt = 0;
  #lastMeasurementTotalProcessingDelay = 0;
  #lastMeasurementTimestamp = Date.now();
  #lastMeasurementFramesDecoded = 0;

  #webrtcLatency = 0;
  #webrtcMeasurementLoop: T_Maybe<number>;

  #detectionLoop: T_Maybe<number>;

  #lastPublishTimestamp: Date = new Date();
  //  webWorker: any = null; // DetectionWebWorker;
  webWorker: DetectionWebWorker;

  webWorkerDetecting = false;
  subjectTrackingEngaged = false;
  #detectionFrameTimestamp: number = 0;
  #detectionWebRTCLatency: number = 0;

  #annotationSubject: string = '';
  #embeddingBeaconSubject: string = '';
  #agentId: Agent['id'];
  #workerId: T_Maybe<string>;
  #deviceId: Device['id'];

  #debug = false;

  constructor() {
    this.checkDebug();
    this.logPublishFPS();
  }

  async checkDebug() {
    const flag = await PostHogManager.getInstance().getFeatureFlag(
      PostHogFeatureFlag.AUTOTRACKING_DEBUG,
      { defaultValue: false }
    );

    this.#debug = flag;
  }

  #loading: boolean = false;
  initCallbacks: (() => void)[] = [];

  async init(livekit: LiveKitImpl, track: MegaTrack): Promise<void> {
    if (this.#loading) {
      await new Promise((resolve) => this.initCallbacks.push(resolve));

      return;
    }
    this.loading = true;

    //    if(this.#loaded)
    //    {
    //      return;
    //    }

    const autoTrackingReadyPromise = new Promise((resolve) => {
      onAutoTrackingReady(() => {
        resolve();
      });
    });

    window.__trackerMask = null;

    this.#livekit = livekit;
    this.#track = track;

    if (this.webWorker) {
      this.webWorker.terminate();
      this.webWorker = null;
    }
    // Spec 4 (D1): the moment the detection worker graph is first constructed.
    // A milestone only — no worker is created or initialized by this line, and
    // whether that graph (and the DINO/WASM assets behind it) lands before the
    // app is usable is answered by the external trace, not by this mark.
    markRendererMilestone('auto-tracking.detection-worker-constructed');
    this.webWorker = new DetectionWebWorker();

    this.webWorker.addEventListener('message', (event) => {
      this.#handleWebWorkerMessage(event);
    });

    // local livekit room
    let lkdata = {};
    if (isElectronApp()) {
      let t = await window.__newAutoTrackingIdentity();
      let firstWsLink = t.uris.find((u) => u.startsWith('ws:'));
      lkdata = { token: t.token, id: t.id, endpoint: firstWsLink };
      if (trackerCPUMode != 'efftam' && trackerCPUMode != 'yolo') {
        setTrackerCPUMode('yolo');
      }
      this.webWorker.postMessage({
        cmd: 'init',
        href: modelPath,
        livekit_data: lkdata,
        trackerMode: trackerCPUMode
      });
    } else {
      // livekit settings for the cloud room: token and endpoint
      // not supported atm: lkdata = window.__livekitCloudData;
      lkdata = undefined;
      setTrackerCPUMode('yolo');
      this.webWorker.postMessage({
        cmd: 'init',
        href: modelPath,
        livekit_data: lkdata,
        trackerMode: trackerCPUMode
      });
    }

    //await autoTrackingReadyPromise;

    this.#loaded = true;
    this.loading = false;

    this.initCallbacks.forEach((cb) => cb());

    this.initCallbacks = [];
  }

  #detect = (source: VideoFrame, timestamp: number, webrtcLatency: number): void => {
    if (!this.webWorker || this.webWorkerDetecting) {
      return;
    }

    this.webWorkerDetecting = true;
    this.#detectionFrameTimestamp = timestamp;
    this.#detectionWebRTCLatency = webrtcLatency;

    this.webWorker.postMessage({ source }, [source]);
  };

  #handleEmbeddings = (embeddings: [string, Float32Array][], blob: Blob | null = null): void => {
    if (blob != null) {
      // render the blob for debug
      window.location.href = URL.createObjectURL(blob);
    }

    const sample = TrackingSample.fromPartial({
      subjects: embeddings.map(([id, emb]) => ({
        id: toIdFromHex(id)!,
        embedding: Array.from(emb)
      }))
    });

    const bytes = TrackingSample.encode(sample).finish();

    nats
      .agentConnection(this.#agentId)
      .publish(this.#annotationSubject + '.embeddings', bytes, { lossy: true });
  };

  #handleWebWorkerMessage = (event: MessageEvent): void => {
    const { latencyAdjustedTimestampGlobal, frameTimestampLocal, cmd } = event.data;

    if (cmd === 'embeddings') {
      this.#handleEmbeddings(event.data.embeddings, event.data.blob);
      return;
    }

    const timestamp = latencyAdjustedTimestampGlobal;
    const results = event.data;

    if (results?.fps) {
      autoTrackingFps[this.#deviceId] = this.#debug ? results?.fps : null;
    }

    //ALSO redetection timeout should start when
    //there are no local detections at all
    if (cmd === 'subject_lost_start') {
      return;
    } else if (cmd === 'subject_lost_end') {
      return;
    }

    if (results.error) {
      console.error('Error from worker', results.error);
      this.webWorkerDetecting = false;
      return;
    }

    if (results.cmd === 'crop_tensor') {
      document.body.innerHTML = "<canvas id='c9353' width='600px' height='600px'></canvas>";

      const canvas = document.getElementById('c9353');

      const ctx = canvas.getContext('bitmaprenderer');

      const img = results.canvas;

      ctx.transferFromImageBitmap(img);

      return;
    }
    void this.#publishResults(results, timestamp);

    this.webWorkerDetecting = false;
  };

  publishFPSRecord: number[] = [];

  #publishResults = async (
    results: {
      ids_data: string[];
      boxes_data: Float32Array;
      scores_data: Float32Array;
      classes_data: Int32Array;
      xRatio: number;
      yRatio: number;
      modelWidth: number;
      modelHeight: number;
    },
    timestamp: number
  ): Promise<void> => {
    if (results?.result?.boxes_data === undefined) {
      return;
    }

    const globalI = this.#globalI++;

    const {
      fps,
      result: {
        ids_data,
        boxes_data,
        scores_data,
        classes_data,
        xRatio,
        yRatio,
        modelWidth,
        modelHeight,
        mask,
        lock,
        embeddings
      },
      frameTimestampLocal
    } = results;

    let headOverride;

    const subjectMap = {};

    for (let i = 0; i < classes_data.length; i++) {
      const score = scores_data[i];

      const box = boxes_data.slice(i * 4, i * 4 + 4);
      /*
      if (mask) {
        const blob = new Blob([mask], { type: 'image/png' });

        const maskUpdateEvent = new CustomEvent('autoTrackingMaskUpdate', {
          detail: { mask: this.#debug ? blob : null }
        });
        window.dispatchEvent(maskUpdateEvent);
      } else {
        window.__trackerMask = null;
        const maskUpdateEvent = new CustomEvent('autoTrackingMaskUpdate', {
          detail: { mask: null }
        });
        window.dispatchEvent(maskUpdateEvent);
      }
*/
      const [y1, x1, y2, x2] = box;

      const width = x2 - x1;
      const height = y2 - y1;

      if (width <= 0 || height <= 0 || isNaN(x1) || isNaN(y1) || isNaN(x2) || isNaN(y2)) {
        continue;
      }

      const id = ids_data?.[i] ? ids_data[i] : generateId();

      var class_type =
        (lock ? SubjectClass.LOCKED_TRACK : classToPB[classes_data[i]]) ??
        SubjectClass.LOCKED_TRACK;
      const subject = {
        x: (x1 * xRatio) / modelWidth,
        y: (y1 * yRatio) / modelHeight,
        width: (width * xRatio) / modelWidth,
        height: (height * yRatio) / modelHeight,
        id: toIdFromHex(id)!,
        class: class_type,
        embedding: embeddings[i]
      };

      subjectMap[id] = subject;
    }

    const timestampFrame = globalI;

    const message = {
      timestampFrame,
      subjects: Object.values(subjectMap),
      frameTimestampLocal,
      latencyAdjustedTimestampGlobal: timestamp
    };

    const sample = TrackingSample.fromPartial(message);

    const bytes = TrackingSample.encode(sample).finish();

    if (this.#lastPublishTimestamp != null) {
      //const diff = new Date().getTime() - this.#lastPublishTimestamp.getTime();
      //const fps = 1000 / diff;
      //console.log("$PUBLISH", JSON.stringify(scores_data), fps);
    } else {
      //console.log("$PUBLISH", message.subjects);
    }

    this.#lastPublishTimestamp = new Date();

    if (this.#annotationSubject === '') {
      return;
    }

    this.publishFPSRecord.push(new Date().getTime());
    /*
        //throttle depending on if subject was selected
        let outputFPS = 15
        if (this.subjectTrackingEngaged) {
            outputFPS = 30;
        }
        const now = Date.now();
        const lastSendElapsed = now - this.lastPublishTime;
        if (!this.lastPublishTime || lastSendElapsed >= 1000/outputFPS) {*/

    const now = Date.now();

    nats.agentConnection(this.#agentId).publish(this.#annotationSubject, bytes, { lossy: true });

    this.lastPublishTime = now;
  };

  calcPublishFPS = (lookback = 5000): void => {
    const now = new Date().getTime();
    const cutoff = now - lookback;

    const records = this.publishFPSRecord.filter((record) => record > cutoff);

    const fps = records.length / (lookback / 1000);

    this.publishFPSRecord = records;

    return fps;
  };

  logPubishInterval: NodeJS.Timeout | null = null;

  logPublishFPS = (): void => {
    if (this.logPubishInterval) {
      clearInterval(this.logPubishInterval);
    }

    this.logPubishInterval = setInterval(() => {
      // calcPublishFPS also prunes stale publishFPSRecord entries; keep the call
      this.calcPublishFPS();
    }, 5000);
  };

  #existingTrack: MegaTrack | undefined;

  detectVideo = (
    track: MegaTrack,
    mediaStream: MediaStreamTrack,
    subject: string,
    agentId: Agent['id'],
    workerId: string,
    deviceId: string,
    embeddingBeaconSubject: string
  ): void => {
    if (this.#existingTrack == track) {
      return;
    }

    this.#existingTrack = track;

    const trackStream = new MediaStreamTrackProcessor(mediaStream);

    this.#agentId = agentId;
    this.#workerId = workerId;
    this.#deviceId = deviceId;
    this.#annotationSubject = subject;
    this.#embeddingBeaconSubject = embeddingBeaconSubject;

    const msg = {
      cmd: 'stream_detect_track',
      trackStream: trackStream.readable
    };

    this.webWorker.postMessage(msg, [trackStream.readable]);

    nats.agentConnection(this.#agentId).subscribe(this.#embeddingBeaconSubject, {
      callback: () => {
        this.webWorker.postMessage({ cmd: 'request_embeddings' });
      }
    });
  };

  //stop active tracking of the selected subject
  stopSubjectTracking = (): void => {
    this.subjectTrackingEngaged = false;
    this.webWorker.postMessage({ cmd: 'stop_subject_tracking' });
    window.__autotracking_redetection_timeout = null;
    clearTimeout(this.redetectionTimeout);

    //const maskUpdateEvent = new CustomEvent('autoTrackingMaskUpdate', { detail: { mask: null } });
    //window.dispatchEvent(maskUpdateEvent);
    //setTimeout(() => {
    //   const maskUpdateEvent = new CustomEvent('autoTrackingMaskUpdate', { detail: { mask: null } });
    //  window.dispatchEvent(maskUpdateEvent);
    //}, 500);
  };

  //stop AT tracking and detection completely
  releaseTracker = (): void => {
    if (!this.webWorker) {
      return;
    }
    this.webWorker.postMessage({ cmd: 'release_tracker' });
    window.__autotracking_redetection_timeout = null;
    clearTimeout(this.redetectionTimeout);
    if (this.logPubishInterval !== null) {
      clearInterval(this.logPubishInterval);
    }
    clearInterval(this.#webrtcMeasurementLoop);
    this.#loaded = false;

    this.#existingTrack = undefined;

    setTimeout(() => {
      this.webWorker.terminate();
      this.webWorker = null;
    }, 500);
  };
}
